<template>
    <div id="Container_GroupAppointmentAdd">

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdLookupMultiSelect
                    ref="lookupPatientRef"
                    v-bind:Label="$tc('Shared.Patient',2)"
                    v-bind:ModelCode="PatientCodeModel"
                    v-bind:RefCode="'patientcode'"
                    v-bind:Api="'Patients'"
                    v-bind:FieldCode="'patientcode'"
                    v-bind:FieldDescription="'firstname'"
                    :SearchTitle="$tc('Shared.Patient',2)"
                    :GetValues="getValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :SearchFieldCode="'PatientCode'"
                    :AuxFields="AuxFields"
                    :FieldsDate="fieldsDate"
                    :ServerSidePagination="true"
                    v-bind:Fields="BaseFields"
                    v-bind:isValid="isPatientsValid"
                    v-bind:isRequired="true"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('Shared.Therapist')"
                    v-bind:Options="TherapistList"
                    v-bind:Model="TherapistVmodel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="false"
                    v-bind:isRequired="true"
                    v-bind:IfUsevalidation="false"
                    :Input="ChangeDropDownTherapist"
                    :isValid="isValidTherapist"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
              <MdSelect
                v-bind:Label="$tc('Shared.AppointmentType')"
                v-bind:Options="AppoinmentTypeList"
                v-bind:Model="AppoinmentTypeVmodel"
                v-bind:FieldDescription="'description'"
                v-bind:FieldCode="'code'"
                v-bind:Placeholder="selectPlaceholder"
                v-bind:Multiple="false"
                v-bind:isRequired="true"
                v-bind:IfUsevalidation="false"
                :Input="ChangeDropDownAppoinmentType"
                :isValid="isValidAppoinmentType"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.Date')"
                    :Model="DateFrom"
                    @input="DatefromChange($event)"
                    :Id="'DateFrom'"
                    :Type="'date'"
                    :isRequired="true"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateFromValid">
                </MdDateTime>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('MdCurrentAppointment.StarTime')"
                    v-bind:TypeProp="'time'"
                    v-model="StartTime"
                    v-bind:Id="'StartTime'"
                    @input="StartTimeChange"
                    :isRequired="true"
                    :isValid="isValidStartTime"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('MdCurrentAppointment.EndTime')"
                    v-bind:TypeProp="'time'"
                    v-model="EndTime"
                    v-bind:Id="'EndTime'"
                    @input="EndTimeChange"
                    :isRequired="true"
                    :isValid="isValidEndTime"/>
            </b-col>
            <b-col md="6" lg="6" sm="12">
                <ejs-recurrenceeditor
                    ref="EditorObj"
                    :change="recurrenceChange"
                    :locale="locale"
                ></ejs-recurrenceeditor>
            </b-col>
        </b-row>

    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import EmployeeService from '@/services/employee.service';
import AppoinmentTypeService from '@/services/appointmenttypes.service'
import Utils from '../../../common/utils'
import { RecurrenceEditorComponent } from '@syncfusion/ej2-vue-schedule';
import SchedulerService from '@/services/schedulers.service'

export default {
    name: 'ScheduleGroupAppointmentAdd',
    mixins: [DBFunctions, ShowMessage],
    components: {
        'ejs-recurrenceeditor': RecurrenceEditorComponent
    },
    props: {
        afterSave: Function
    },

    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                btnvisible: false,
                ItemsList: [],
                favButtonAtion: false
            },
            fullParam: {
                PageSize: 0,
                PageNumber: 0,
                Active: true
            },
            PatientCodeModel: [],
            isPatientsValid: true,
            locale: localStorage.language,
            selectPlaceholder: this.$t('Shared.SelectOptions'),
            TherapistList: [],
            TherapistVmodel: '',
            isValidTherapist: true,
            AppoinmentTypeList: [],
            AppoinmentTypeVmodel: "",
            isValidAppoinmentType: true,
            DateFrom: Utils.formatterDate(new Date()),
            isDateFromValid: true,
            StartTime: Utils.formatTimeHm(new Date()),
            isValidStartTime: true,
            EndTime: null,
            isValidEndTime: true,

            AuxFields:['lastname'],
            fieldsDate:['dob'],
            BaseFields:[
                { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
                { key: 'lastname', sortable: true, label: this.$t('Shared.LastName')},
                { key: 'patientcode', sortable: true, label: this.$t('Shared.Code')},
                { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone')},
                { key: 'address1', sortable: true, label: this.$t('Shared.Address1')},
                { key: 'city', sortable: true, label: this.$t('Shared.City')},
                { key: 'state', sortable: true, label: this.$t('Shared.State')},
                { key: 'country', sortable: true, label: this.$t('Shared.Country')},
                { key: 'zip', sortable: true, label: this.$t('Shared.Zip')}
            ],
            Recurrence: null,
            data: {
                PatientList: [],
                Therapistcode: null,
                Activitytypecode: null,
                Timein: Utils.formatTime2(new Date()),
                Timeout: null,
                Transdate: Utils.formatterDate(new Date()),
                RecurrenceRule: null
            }
        };
    },


    methods: {

        async InsertGroupAppointment() {
            await SchedulerService
                .InsertGroupAppointment(this.data)
                .then(response => {
                    if (response.status == '200') {
                        this.afterSave()
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        recurrenceChange: function(args) {
            this.data.RecurrenceRule = args.value;
        },

        removeNeverEndOption() {
            const editor = this.$refs.EditorObj && this.$refs.EditorObj.ej2Instances;
            const endType = editor && editor.endType;
            if (endType) {
                endType.dataSource = endType.dataSource.filter(item => item.value !== 'never');
                if (endType.value === 'never') {
                    endType.value = 'until';
                }
                endType.dataBind();
            }
        },

        validation() {
            this.isPatientsValid = this.PatientCodeModel.length > 0 ? true : false
            this.isValidStartTime = Utils.isValidTime(this.StartTime) ? true : false
            this.isValidEndTime = Utils.isValidTime(this.EndTime) ? true : false
            this.isValidAppoinmentType = this.AppoinmentTypeVmodel ? true : false
            this.isValidTherapist = this.TherapistVmodel ? true : false
            this.isDateFromValid = Utils.isValidDate(this.DateFrom) ? true : false

            return this.isValidStartTime && this.isValidEndTime && this.isPatientsValid &&
                this.isValidAppoinmentType && this.isValidTherapist
        },

        async save() {
            if (this.validation()) {
                await this.InsertGroupAppointment()
            }
        },

        getValues: async function (value) {
            this.PatientCodeModel = value
            this.data.PatientList = value
        },

        DatefromChange(value) {
            this.isDateFromValid = value ? true : false
            this.data.Transdate = value
            this.DateFrom  = value
        },

        StartTimeChange(time) {
            this.isValidStartTime = Utils.isValidTime(time) ? true : false
            this.data.Timein = Utils.formatTime2(time)
            this.StartTime = time
        },

        EndTimeChange(time) {
            this.isValidEndTime = Utils.isValidTime(time) ? true : false
            this.data.Timeout = Utils.formatTime2(time)
            this.EndTime = time
        },

        ChangeDropDownTherapist(therapists) {
            this.TherapistVmodel = therapists;
            this.isValidTherapist = this.TherapistVmodel ? true : false
            this.data.Therapistcode = therapists && therapists.code ? therapists.code : null
        },

        ChangeDropDownAppoinmentType(appttypes){
            this.AppoinmentTypeVmodel = appttypes;
            this.isValidAppoinmentType = this.AppoinmentTypeVmodel ? true : false
            this.data.Activitytypecode = appttypes && appttypes.code ? appttypes.code.trim() : null;
        },

        getEmployees() {
            EmployeeService.getAll(this.fullParam)
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.TherapistList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getAppointmentTypes() {
            AppoinmentTypeService.getListing()
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.AppoinmentTypeList = response.data;
                }
              })
              .catch(error => {
                if (!error.response) {
                // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });
        },

        DiscardChanges() {
            this.$router.push({
              name: "ScheduleGroupAppointmentList"
            });
        },
    },

    created() {
        this.getEmployees();
        this.getAppointmentTypes();
    },

    mounted() {
        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;
        this.OptionsRightMenu.ItemsList = [];
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.$nextTick(this.removeNeverEndOption);
    }
};
</script>
